/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Username_Existing_AccountInputs */

const en_onboarding_v1_username_existing_account = /** @type {(inputs: Onboarding_V1_Username_Existing_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account?`)
};

const de_onboarding_v1_username_existing_account = /** @type {(inputs: Onboarding_V1_Username_Existing_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haben Sie bereits ein Konto?`)
};

const pt_br2_onboarding_v1_username_existing_account = /** @type {(inputs: Onboarding_V1_Username_Existing_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já tem uma conta?`)
};

const tr_onboarding_v1_username_existing_account = /** @type {(inputs: Onboarding_V1_Username_Existing_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaten hesabınız var mı?`)
};

const zh_cn2_onboarding_v1_username_existing_account = /** @type {(inputs: Onboarding_V1_Username_Existing_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已经有账户？`)
};

const zh_hk2_onboarding_v1_username_existing_account = /** @type {(inputs: Onboarding_V1_Username_Existing_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已經有帳戶？`)
};

const ko_kr2_onboarding_v1_username_existing_account = /** @type {(inputs: Onboarding_V1_Username_Existing_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 계정이 있으신가요?`)
};

const ru_ru2_onboarding_v1_username_existing_account = /** @type {(inputs: Onboarding_V1_Username_Existing_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У вас уже есть аккаунт?`)
};

const es_419_onboarding_v1_username_existing_account = /** @type {(inputs: Onboarding_V1_Username_Existing_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Ya tienes una cuenta?`)
};

/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Onboarding_V1_Username_Existing_AccountInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_username_existing_account = /** @type {((inputs?: Onboarding_V1_Username_Existing_AccountInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Username_Existing_AccountInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_username_existing_account(inputs)
	if (locale === "de") return de_onboarding_v1_username_existing_account(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_username_existing_account(inputs)
	if (locale === "tr") return tr_onboarding_v1_username_existing_account(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_username_existing_account(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_username_existing_account(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_username_existing_account(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_username_existing_account(inputs)
	return es_419_onboarding_v1_username_existing_account(inputs)
});